"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigSchema = void 0;
const zod_1 = require("zod");
// @MV TODO: update below structure
exports.ConfigSchema = zod_1.z.object({});
//# sourceMappingURL=RefreshConfig.js.map